/**
 * ChatPageHeader Component
 * Custom header for Chat page with WebSocket status
 */

import React from 'react';
import { useWebSocketStatus } from '@/context/WebSocketContext';
import './ChatPageHeader.css';

export const ChatPageHeader: React.FC = () => {
  const { connected } = useWebSocketStatus();

  return (
    <div className="chat-page-header">
      <h1 className="chat-page-title">General Chat</h1>
      <div className="chat-page-status">
        <span
          className="chat-page-status-dot"
          style={{
            backgroundColor: connected ? '#52c41a' : '#ff4d4f',
          }}
        />
        <span className="chat-page-status-text">
          WebSocket: {connected ? 'Connected' : 'Disconnected'}
        </span>
      </div>
    </div>
  );
};
